import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const Section = (props) => {
  let className = props.className ? props.className : '';
  return (
    <section className={className}>
      <h2 className="heading">
        {props.url ? (
          /(http(s?)):\/\//gi.test(props.url) ? (
            <a href={props.url}>{props.title}</a>
          ) : (
            <Link to={props.url}>{props.title}</Link>
          )
        ) : (
          props.title
        )}
      </h2>
      {props.subHeading ? <p className="sub-heading">{props.subHeading}</p> : null}
      {props.children}
    </section>
  );
};

Section.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  subHeading: PropTypes.string,
  url: PropTypes.string,
};

export default Section;
